// extracted by mini-css-extract-plugin
module.exports = {"fadeInUp":"style_fadeInUp__1zJc6"};